import { useCallback } from 'react';
import { graphql, useGqlContext } from '@search/gql-client/src';

import type {
    usePromoOnlinePurchase2EmailMutationResponse,
    usePromoOnlinePurchase2EmailMutationVariables
} from './__generated__/usePromoOnlinePurchase2EmailMutation.graphql';

const mutation = graphql`
    mutation usePromoOnlinePurchase2EmailMutation(
        $startCallbackHour: String
        $endCallbackHour: String
        $phone: String!
        $name: String
        $offerLink: String,
        $isRequest: Boolean
    ) {
        purchaseCallback(
            name: $name
            phone: $phone
            startCallbackHour: $startCallbackHour
            endCallbackHour: $endCallbackHour
            link: $offerLink,
            isRequest: $isRequest
        ) {
            emailMessageId
        }
    }
`;

export function usePromoOnlinePurchase2EmailMutation() {
    const gql = useGqlContext();

    return useCallback(
        (vars: usePromoOnlinePurchase2EmailMutationVariables, opts?: { signal?: AbortSignal }) => gql.client<
            usePromoOnlinePurchase2EmailMutationVariables,
            usePromoOnlinePurchase2EmailMutationResponse
        >(
            mutation,
            vars,
            opts
        ),
        [ gql ]
    );
}
